import { render } from "./AssuntoTree.vue?vue&type=template&id=196ea0ad&scoped=true"
import script from "./AssuntoTree.vue?vue&type=script&lang=js"
export * from "./AssuntoTree.vue?vue&type=script&lang=js"

import "./AssuntoTree.vue?vue&type=style&index=0&id=196ea0ad&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196ea0ad"]])

export default __exports__